// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"30b82159","290":"bcb2ab53","716":"006493cf"}[chunkId] + ".chunk.js";
};